import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useState} from 'react'
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {Avatar, Input, Tabs} from "antd";
import {renderIf, renderIfElse} from "../../../Shared";
import _ from "lodash";
import Translate from "../../../../modules/local/Translate";
import {compose, mapProps, pure, withProps} from "recompose";
import withTranslate from "../../../../modules/local/withTranslate";
import {createControlledFormField} from "../../factory/createFormField";
import {baseFieldTypes} from "../../../../apis/base/baseFieldTypes";
import {Formik} from "formik";
import FormActionBar from "../../../../components/form/FormActionBar";
import {NullAsDefault, shallowDiff} from 'views/Shared'
import {GoDotFill} from "react-icons/go";
import {HeaderWithIconLine} from "../../Templates/items/ListHeader";
import {ItemInformation} from 'components/common/ItemInformation'
import {isRawContentEmpty} from "../../../SlateEditor/functions/parseRawContent";
import SlateEditor, {SlateRenderer} from "../../../SlateEditor";
import {convertFromString, convertToString} from "../../../SlateEditor/functions";
import EmptyHolder from "../../../../components/EmptyHolder";
import PhotoField from "../../custom/PhotoField";
import {ModalEditorToolbar} from "../../../SlateEditor/SlateEditor";
import {createValue} from "../../../../components/form/utils";
import LinkedPages from "../../../Organization/Settings/Profile/LinkedPages";
import LookupField from "../../../../components/LookupField";
import {CountryPicker} from "../../User/functions/renderLocationCascade";
import {SaintsOutlineSvg} from "../../../../components/Svgs/SaintsPlaceholder";
import {ReligiousFillSvg} from "../../../../components/Svgs/ReligiousIconSvg";
import {useReligiousOrders} from "../functions/useReligiousOrders";
import {AuthorityTypeInfos} from "../consts/AuthorityTypes";
import {NatureTypeInfos} from "../consts/NatureTypes";
import {MdChurch} from "react-icons/md";
import {RiMapPinFill} from "react-icons/ri";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {Link} from "react-router-dom";
import {ActionModalWrapper} from "../../../../components/form/ActionModalWrapper";
import {LoginContext} from "../../../../components/LoginContext";
import {isSystemAdmin} from "../../../../helpers/authUtils";
import {ChipGroup, createSlateTab, Field, FormActions, Section} from "../../../../components/form/ModernForm";
import {
    IoBookOutline,
    IoBusinessOutline,
    IoCallOutline,
    IoDocumentTextOutline,
    IoEarthOutline,
    IoGitNetworkOutline,
    IoImageOutline,
    IoLinkOutline,
    IoPeopleOutline,
    IoRibbonOutline,
    IoSchoolOutline,
    IoStarOutline,
    IoStatsChartOutline,
} from "react-icons/io5";

export const TargetGenderTypes = Object.freeze({
    Male: {
        name: 'male',
        label: 'male',
        value: 1,
    },
    Female: {
        name: 'female',
        label: 'female',
        value: 2,
    },
    Both: {
        name: 'both',
        label: 'both',
        value: 3,
    },
})

const formSchema = {
    photo: {
        title: 'avatar',
        children: [
            {
                name: 'photo',
                component: ({name, value, form, onChange}) => (
                    <LayoutContext.Consumer>
                        {({isSm}) => (
                            <Translate>
                                {(t) => (
                                    <div className="flex flex-col gap-1">
                                        <span
                                            className="text-xs text-color-500 italic">{`* ${t('description size avatar')}`}</span>
                                        <PhotoField
                                            Wrapper={({children}) => (
                                                <div className="flex flex-col flex-center relative">
                                                    {children}
                                                </div>
                                            )}
                                            className="background"
                                            cropPurpose="avatar"
                                            cropShape="rect"
                                            square
                                            style={{
                                                padding: 0,
                                                minWidth: isSm ? 140 : 180,
                                                minHeight: isSm ? 140 : 180,
                                                maxWidth: isSm ? 140 : 180,
                                                maxHeight: isSm ? 140 : 180,
                                            }}
                                            values={_.get(form, 'values')}
                                            {...{name, value, onChange}}
                                        />
                                    </div>
                                )}
                            </Translate>
                        )}
                    </LayoutContext.Consumer>
                ),
            },
        ],
    },
    name_short_name: {
        children: [
            {
                label: 'name of religious', name: 'name',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        onChange,
                        type: 'text',
                        placeholder: translate('name of religious'),
                    })),
                    pure
                )(Input),
            },
            {

                label: 'short name',
                name: 'short_name',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        onChange,
                        type: 'text',
                        placeholder: translate('short name'),
                    })),
                    pure
                )(Input),
            },
        ],
    },

    parent: {
        title: 'the branch congregation of',
        children: [
            {
                name: 'parent',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <LookupField
                                title={t('choose religious orders')}
                                createIfNotExists={false}
                                defaultValue={form?.values?.parent_name}
                                selectedOption={form?.values?.parent}
                                apiPath={`/lookup/religious_order/get-by-types`}
                                name={name}
                                placeholder={t('click to select')}
                                OptionWrapper={({children, ...props}) =>
                                    <div
                                        className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                        {children}
                                    </div>
                                }
                                renderOption={(o, i) => {
                                    return (
                                        <div key={i} className="flex items-center flex-1 gap-3">
                                            <Avatar
                                                size={60}
                                                src={o.avatar}
                                                icon={<ReligiousFillSvg size={30} className="text-color-500"/>}
                                                className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                            />
                                            <div className="flex flex-col gap-1 flex-1">
                                                  <span className="font-bold text-color-000 leading-tight">
                                                    {o.name}
                                                  </span>
                                                {renderIfElse(
                                                    o?.religious_order_group,
                                                    <span className="font-medium text-xs text-blue-500 italic">
                                    {o?.religious_order_group}
                                  </span>,
                                                    <span className="text-xs text-color-400 italic max-lines-2">
                                    {o?.description}
                                  </span>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }}
                                handleChange={(e) => {
                                    // onChange(createValue('parent', e.target))
                                    // onChange(createValue('parent_name', e.target.value))
                                    // onChange(createValue('parent_id', e.target.id
                                    form.setValues({
                                        ...form.values,
                                        parent: e.target,
                                        parent_name: e.target.value,
                                        parent_id: e.target.id
                                    })
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },
    religious_order_group: {
        title: 'religious order group',
        children: [
            {
                name: 'religious_order_group',
                component: ({name, value, onChange, form}) => {
                    const values = _.get(form, 'values', {})
                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    title={t('choose religious orders')}
                                    createIfNotExists={true}
                                    defaultValue={values?.religious_order_group}
                                    apiPath={`/lookup/religious_order_group/gets`}
                                    name={name}
                                    placeholder={t('click to select')}
                                    handleChange={(e) => {
                                        onChange(createValue('religious_order_group', e.target.value))
                                    }}
                                    OptionWrapper={({children, ...props}) =>
                                        <div
                                            className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                            {children}
                                        </div>
                                    }
                                    renderOption={(o, i) => {
                                        return (
                                            <div key={i} className="flex items-center flex-1 gap-3">
                                                <Avatar
                                                    size={60}
                                                    src={o.avatar}
                                                    className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                    icon={<ReligiousFillSvg size={30} className="text-color-500"/>}
                                                />
                                                <div className="flex flex-col flex-1">
                                                    <span
                                                        className="font-bold text-sm text-color-000 leading-tight">{o.name}</span>
                                                    {renderIf(
                                                        o?.description,
                                                        <span
                                                            className="text-xs text-color-400 italic max-lines-2">{o?.description}</span>
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
    patron_saint: {
        children: [
            {
                label: 'patron saint',
                name: 'patron_saint',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <LookupField
                                title={t('patron saint')}
                                createIfNotExists={true}
                                defaultValue={form?.values?.patron_saint_name}
                                selectedOption={form?.values?.patron_saint}
                                apiPath={`/lookup/saint/get-by-types`}
                                name={name}
                                OptionWrapper={({children, ...props}) =>
                                    <div
                                        className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                        {children}
                                    </div>
                                }
                                renderOption={(o, i) => {
                                    return (
                                        <div key={i} className="flex items-center flex-1 gap-3">
                                            <Avatar
                                                size={60}
                                                src={o.avatar}
                                                className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                icon={<SaintsOutlineSvg size={30} style={{color: '#dddddd'}}/>}
                                            />
                                            <div className="flex flex-col flex-1 max-lines-3">
                                                <span className="font-bold text-sm text-color-000 leading-tight">
                                                    {`${o.common_name || o.name} (${o.patron_saint_feast_day || o.feast_day})`}
                                                </span>
                                                {renderIf(
                                                    o?.description,
                                                    <span
                                                        className="text-xs text-color-400 italic max-lines-2 leading-snug">{o?.description}</span>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }}
                                handleChange={(e) => {
                                    form.setValues({
                                        ...form.values,
                                        patron_saint: e.target,
                                        patron_saint_name: e.target.common_name || e.target.value,
                                        patron_saint_feast_day: e.target.feast_day,
                                        patron_saint_id: e.target.id
                                    })
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },
    contact_phone_name: {
        children: [
            {
                label: 'contact name',
                name: 'contact_name',
                component: createControlledFormField({
                    placeholder: 'full name',
                    Component: Input,
                }),
            },
            {
                label: 'phone',
                name: 'contact_phone',
                component: createControlledFormField({
                    type: 'tel',
                    placeholder: 'ex: phone',
                    Component: Input,
                }),
            },
        ],
    },
    country: {
        title: 'country',
        children: [
            {
                name: 'country_id',
                component: compose(
                    withProps({
                        withChangedValues: (values) => ({
                            location: [, , ,],
                        }),
                        allowClear: true,
                    })
                )(CountryPicker),
            },
        ],
    },
    diocese_location: {
        inline: true,
        children: [
            {
                label: 'belong to diocese',
                name: 'diocese',
                component: ({name, value, onChange, form, ...restForm}) => {

                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    title={t('choose diocese')}
                                    createIfNotExists={true}
                                    defaultValue={form?.values?.diocese_name}
                                    selectedOption={form?.values?.diocese}
                                    placeholder={t('click to select / create')}
                                    apiPath={`/lookup/diocese/get-by-types?country_id=${form?.values?.country_id}`}
                                    name={name}
                                    OptionWrapper={({children, ...props}) =>
                                        <div
                                            className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                            {children}
                                        </div>
                                    }
                                    renderOption={(o, i) => {
                                        const {fullname, location_address} = o ?? {}
                                        return (
                                            <div key={i} className="flex items-center flex-1 gap-3">
                                                <Avatar
                                                    size={50}
                                                    src={o.avatar}
                                                    className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                    icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
                                                />
                                                <div className="py-2 md:py-0 flex flex-col flex-1 min-w-0 gap-1">
                                                    <div className="space-x-1 leading-snug">
                                                              <span className="font-bold text-sm text-color-000">
                                                                  {fullname}
                                                              </span>
                                                    </div>
                                                    {renderIf(
                                                        location_address,
                                                        <div className="flex items-center gap-x-1">
                                                            <RiMapPinFill size={11} className="text-color-400"/>
                                                            <span
                                                                className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                                                    {location_address}
                                                                  </span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    }}
                                    handleChange={(e) => {
                                        form.setValues({
                                            ...form.values,
                                            diocese: e.target,
                                            diocese_name: e.target?.value,
                                            diocese_id: e.target?.id
                                        });
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
    foundation: {
        children: [
            {
                label: 'founder name', name: 'founder_name',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        defaultValue: value,
                        onChange,
                        type: 'text',
                        placeholder: translate('founder name'),
                    })),
                    pure
                )(Input),
            },
            {
                label: 'founding year', name: 'founding_year',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        defaultValue: value,
                        onChange,
                        type: 'number',
                        placeholder: translate('founding year'),
                    })),
                    pure
                )(Input),
            },
        ],
    },

    motto: {
        title: 'motto',
        children: [
            {
                name: 'motto',
                component: compose(
                    withTranslate,
                    mapProps(({onChange, value, translate}) => ({
                        onChange,
                        value,
                        name: 'motto',
                        placeholder: translate('ex: address'),
                        type: 'text',
                    }))
                )(Input),
            },
        ],
    },
    address: {
        title: 'address',
        children: [
            {
                name: 'contact_address',
                component: compose(
                    withTranslate,
                    mapProps(({onChange, value, translate}) => ({
                        onChange,
                        value,
                        name: 'contact_address',
                        placeholder: translate('ex: address'),
                        type: 'text',
                    }))
                )(Input),
            },
        ],
    },
    about: {
        title: 'about religious orders',
        children: [
            {
                name: 'about',
                component: createControlledFormField({
                    Component: SlateEditor,
                    ToolbarComponent: ModalEditorToolbar,
                    withProps: ({value}) => ({
                        defaultValue: value,
                    }),
                    withValues: ({resetKey}) => ({
                        resetKey,
                    }),
                }),
            },
        ],
    },
    history: {
        title: 'history diocese',
        children: [
            {
                name: 'history',
                component: createControlledFormField({
                    Component: SlateEditor,
                    ToolbarComponent: ModalEditorToolbar,
                    withProps: ({value}) => ({
                        defaultValue: value,
                    }),
                    withValues: ({resetKey}) => ({
                        resetKey,
                    }),
                }),
            },
        ],
    },
    bishops: {
        title: 'bishops',
        children: [
            {
                name: 'bishops',
                component: createControlledFormField({
                    Component: SlateEditor,
                    ToolbarComponent: ModalEditorToolbar,
                    withProps: ({value}) => ({
                        defaultValue: value,
                    }),
                    withValues: ({resetKey}) => ({
                        resetKey,
                    }),
                }),
            },
        ],
    },
    saints: {
        title: 'saints',
        children: [
            {
                name: 'saints',
                component: createControlledFormField({
                    Component: SlateEditor,
                    ToolbarComponent: ModalEditorToolbar,
                    withProps: ({value}) => ({
                        defaultValue: value,
                    }),
                    withValues: ({resetKey}) => ({
                        resetKey,
                    }),
                }),
            },
        ],
    },
    members: {
        title: 'members',
        children: [
            {
                name: 'members',
                component: createControlledFormField({
                    Component: SlateEditor,
                    ToolbarComponent: ModalEditorToolbar,
                    withProps: ({value}) => ({
                        defaultValue: value,
                    }),
                    withValues: ({resetKey}) => ({
                        resetKey,
                    }),
                }),
            },
        ],
    },
    churches: {
        title: 'deanery - parish',
        children: [
            {
                name: 'churches',
                component: createControlledFormField({
                    Component: SlateEditor,
                    ToolbarComponent: ModalEditorToolbar,
                    withProps: ({value}) => ({
                        defaultValue: value,
                    }),
                    withValues: ({resetKey}) => ({
                        resetKey,
                    }),
                }),
            },
        ],
    },
    statistics: {
        title: 'other information',
        children: [
            {
                name: 'statistics',
                component: createControlledFormField({
                    Component: SlateEditor,
                    ToolbarComponent: ModalEditorToolbar,
                    withProps: ({value}) => ({
                        defaultValue: value,
                    }),
                    withValues: ({resetKey}) => ({
                        resetKey,
                    }),
                }),
            },
        ],
    },
    websites: {
        title: 'Linked Pages',
        name: 'websites',
        component: compose(
            mapProps(
                ({name, value, onChange}) => ({
                    data: value,
                    classNames: [
                        "grid grid-cols-3 md:grid-cols-4 gap-2 mb-2",
                        "col-span-2 md:col-span-3"
                    ],
                    onChange: value => {
                        onChange(createValue(name, value))
                    },
                })),
            pure
        )(LinkedPages)
    },
}

// Tái dùng thẳng các component field đã có sẵn trong formSchema (LookupField, PhotoField,
// CountryPicker, SlateEditor, LinkedPages...) thay vì viết lại - chỉ đổi khung ngoài (Section/
// Field) cho Create/EditReligiousOrderForm, cùng pattern đã dùng ở ProfileForm.js/ParishForm.js/
// DioceseForm.js.
const PhotoInput = formSchema.photo.children[0].component
const NameInput = formSchema.name_short_name.children[0].component
const ShortNameInput = formSchema.name_short_name.children[1].component
const ParentInput = formSchema.parent.children[0].component
const ReligiousOrderGroupInput = formSchema.religious_order_group.children[0].component
const PatronSaintInput = formSchema.patron_saint.children[0].component
const ContactNameInput = formSchema.contact_phone_name.children[0].component
const ContactPhoneInput = formSchema.contact_phone_name.children[1].component
const CountryInput = formSchema.country.children[0].component
const DioceseInput = formSchema.diocese_location.children[0].component
const FounderNameInput = formSchema.foundation.children[0].component
const FoundingYearInput = formSchema.foundation.children[1].component
const MottoInput = formSchema.motto.children[0].component
const AddressInput = formSchema.address.children[0].component
const AboutInput = formSchema.about.children[0].component
const HistoryInput = formSchema.history.children[0].component
const BishopsInput = formSchema.bishops.children[0].component
const SaintsInput = formSchema.saints.children[0].component
const MembersInput = formSchema.members.children[0].component
const ChurchesInput = formSchema.churches.children[0].component
const StatisticsInput = formSchema.statistics.children[0].component
const WebsitesInput = formSchema.websites.component


const useIsSuperAdmin = () => {
    const login = useContext(LoginContext)
    return isSystemAdmin(login)
}

// Placeholder chuẩn khi 1 khối dữ liệu (Giám mục / Hiển thánh / Thành viên / Nhà thờ...) chưa có nội dung.
// Nút "+ Bổ sung thông tin" chỉ hiện với super admin.
const EmptyBlock = ({description = 'No data available', onAdd}) => {
    const t = useTranslate()
    const isAdmin = useIsSuperAdmin()
    return (
        <div
            className="p-3 border border-dashed border-color-100 rounded-lg flex flex-col flex-center gap-1 text-center">
            <span className="text-xs text-color-500 italic leading-snug">{t(description)}</span>
            {renderIf(
                isAdmin && onAdd,
                <span
                    onClick={onAdd}
                    className="mt-1 font-medium text-xs text-blue-500 hover:text-blue-600 cursor-pointer tracking-wide">
                    {`+ ${t('add information')}`}
                </span>
            )}
        </div>
    )
}

const InformationTab = ({item, onEdit}) => {
    const t = useTranslate()
    const {
        motto,
        founding_year,
        founder_name,
        highlighted,
        description,
        short_name,
        patron_saint,
        target_gender,
        contact_name,
        contact_phone,
        contact_address,
        websites = [],
        parent,
        nature_typecd,
        diocese_name,
        authority_typecd,
        churches,
    } = item ?? {}

    const gender = _.find(TargetGenderTypes, {value: target_gender || parent?.target_gender})?.label

    const {showDetailModal, detailModal} = useReligiousOrders({
        notifyListeners: {},
    })

    return (
        <div className="flex flex-col gap-2">
            {renderIf(
                description,
                <div className="ml-6 my-2 text-sm text-color-300 tracking-wider">
                    {description}
                </div>
            )}
            <HeaderWithIconLine
                icon={<GoDotFill size={14} className="text-color-500"/>}
                title="religious orders information"
                className="text-sm text-color-400"
            />
            <div className="ml-5 flex flex-col gap-2">
                {renderIf(
                    short_name,
                    <ItemInformation label="short name" value={short_name} className="text-sm"/>
                )}
                {renderIf(
                    patron_saint,
                    <div className="flex items-baseline gap-1 text-sm">
                        <span className="text-color-500 whitespace-no-wrap italic">{`${t('patron saint')} : `}</span>
                        <Link to={getLinkToDetail(patron_saint)} target="_blank"
                              className="font-medium text-primary-600 no-underline">
                            {patron_saint?.common_name}
                        </Link>
                    </div>
                )}
                {renderIf(
                    parent,
                    <div className="flex items-baseline gap-1 text-sm">
                        <span className="text-color-500 whitespace-no-wrap italic">
                            {`${t('the branch congregation of')} : `}
                        </span>
                        <span
                            onClick={() => {
                                showDetailModal(parent)
                            }}
                            className="font-semibold text-primary-400 hover:text-primary cursor-pointer">
                            {`${parent?.name} (${parent?.short_name})`}
                        </span>
                    </div>
                )}
                <ItemInformation label="target gender" value={t(gender)} className="text-sm"/>
                <ItemInformation label="authority type" value={t(authority_typecd)} className="text-sm"/>
                <ItemInformation label="nature type" value={t(_.find(NatureTypeInfos, {value: nature_typecd})?.label)}
                                 className="text-sm"/>
                <ItemInformation label="belong to diocese" value={diocese_name} className="text-sm"/>
                {renderIf(
                    websites?.length > 0,
                    websites.map((e, i) => !!e?.url && (
                        <div key={i} className="flex-1 items-baseline gap-1">
                            <span className="text-color-500 italic">{`${e?.page} : `}</span>
                            <a key={i} href={e?.url} target="_blank"
                               className="font-medium text-sm text-color-100 hover:text-primary-500 no-underline">
                                {e?.url}
                            </a>
                        </div>
                    ))
                )}
            </div>
            <HeaderWithIconLine
                icon={<GoDotFill size={14} className="text-color-500"/>}
                title="contact information"
                className="text-sm text-color-400 mt-3"
            />
            {renderIfElse(
                _.some([contact_name, contact_phone, contact_address]),
                <div className="ml-5 flex flex-col gap-2">
                    {renderIf(
                        contact_name,
                        <ItemInformation label="contact name" value={contact_name} className="text-sm"/>
                    )}
                    {renderIf(
                        contact_phone,
                        <ItemInformation label="phone" value={contact_phone} className="text-sm"/>
                    )}
                    {renderIf(
                        contact_address,
                        <ItemInformation label="address" value={contact_address} className="text-sm"/>
                    )}
                </div>,
                <EmptyHolder/>
            )}
            <HeaderWithIconLine
                icon={<GoDotFill size={14} className="text-color-500"/>}
                title="churches"
                className="text-sm text-color-400 mt-3"
            />
            <div className="ml-5">
                {renderIfElse(
                    !isRawContentEmpty(churches),
                    <div style={{fontSize: 13}}>
                        <SlateRenderer value={convertFromString(churches)}/>
                    </div>,
                    <EmptyBlock onAdd={onEdit}/>
                )}
            </div>
            {detailModal}
        </div>
    )
}

const AboutReligiousOrders = ({item, onEdit}) => {
    const t = useTranslate()
    const {about, history, statistics} = item ?? {}
    return (
        <div className="flex flex-col gap-3">
            <div className="flex flex-col">
                <HeaderWithIconLine
                    renderTitle={() => (
                        <div className="flex items-center gap-2">
                            <GoDotFill size={14} className="text-color-500"/>
                            <span className="font-semibold text-sm text-color-400 uppercase tracking-wider">
                                {t('introduce')}
                            </span>
                        </div>
                    )}
                />
                {renderIfElse(
                    !isRawContentEmpty(about),
                    <div style={{fontSize: 13}} className="ml-3">
                        <SlateRenderer value={convertFromString(about)}/>
                    </div>,
                    <div className="ml-3">
                        <EmptyBlock onAdd={onEdit}/>
                    </div>
                )}
            </div>
            <div className="flex flex-col">
                <HeaderWithIconLine
                    renderTitle={() => (
                        <div className="flex items-center gap-2">
                            <GoDotFill size={14} className="text-color-500"/>
                            <span className="font-semibold text-sm text-color-400 uppercase tracking-wider">
                            {t('history of formation')}
                        </span>
                        </div>
                    )}
                />
                {renderIfElse(
                    !isRawContentEmpty(history),
                    <div style={{fontSize: 13}} className="ml-3">
                        <SlateRenderer value={convertFromString(history)}/>
                    </div>,
                    <div className="ml-3">
                        <EmptyBlock onAdd={onEdit}/>
                    </div>
                )}
            </div>
            {renderIf(
                !isRawContentEmpty(statistics),
                <StatisticsReligiousOrders item={statistics}/>
            )}
        </div>
    )
}

const BishopsReligiousOrders = ({item, onEdit}) => {
    const t = useTranslate()
    return (
        <div className="flex flex-col">
            <HeaderWithIconLine
                renderTitle={() => (
                    <div className="flex items-center gap-2">
                        <GoDotFill size={14} className="text-color-500"/>
                        <span className="font-semibold text-sm text-color-400 uppercase tracking-wider">
                        {t('bishop')}
                    </span>
                    </div>
                )}
            />
            {renderIfElse(
                !isRawContentEmpty(item),
                <div style={{fontSize: 13}} className="ml-3">
                    <SlateRenderer value={convertFromString(item)}/>
                </div>,
                <div className="ml-3">
                    <EmptyBlock onAdd={onEdit}/>
                </div>
            )}
        </div>
    )
}

const SaintsReligiousOrders = ({item, onEdit}) => {
    const t = useTranslate()
    return (
        <div className="flex flex-col">
            <HeaderWithIconLine
                renderTitle={() => (
                    <div className="flex items-center gap-2">
                        <GoDotFill size={14} className="text-color-500"/>
                        <span className="font-semibold text-sm text-color-400 uppercase tracking-wider">
                            {t('saints')}
                        </span>
                    </div>
                )}
            />
            {renderIfElse(
                !isRawContentEmpty(item),
                <div style={{fontSize: 13}} className="ml-3">
                    <SlateRenderer value={convertFromString(item)}/>
                </div>,
                <div className="ml-3">
                    <EmptyBlock onAdd={onEdit}/>
                </div>
            )}
        </div>
    )
}

const MembersReligiousOrders = ({item, onEdit}) => {
    const t = useTranslate()
    return (
        <div className="flex flex-col">
            <HeaderWithIconLine
                renderTitle={() => (
                    <div className="flex items-center gap-2">
                        <GoDotFill size={14} className="text-color-500"/>
                        <span className="font-semibold text-sm text-color-400 uppercase tracking-wider">
                        {t('prominent member')}
                    </span>
                    </div>
                )}
            />
            {renderIfElse(
                !isRawContentEmpty(item),
                <div style={{fontSize: 13}} className="ml-3">
                    <SlateRenderer value={convertFromString(item)}/>
                </div>,
                <div className="ml-3">
                    <EmptyBlock onAdd={onEdit}/>
                </div>
            )}
        </div>
    )
}

// Gộp Giám mục / Hiển thánh / Thành viên vào 1 tab "Nhân sự" để giảm số tab của phân hệ dòng tu.
const PersonnelTab = ({item, onEdit}) => {
    const {bishops, saints, members} = item ?? {}
    return (
        <div className="flex flex-col gap-3">
            <BishopsReligiousOrders item={bishops} onEdit={onEdit}/>
            <SaintsReligiousOrders item={saints} onEdit={onEdit}/>
            <MembersReligiousOrders item={members} onEdit={onEdit}/>
        </div>
    )
}

const countPopulatedPersonnel = ({bishops, saints, members} = {}) =>
    [bishops, saints, members].filter((e) => !isRawContentEmpty(e)).length

const StatisticsReligiousOrders = ({item}) => {
    const t = useTranslate()
    return (
        <div className="flex flex-col mt-3">
            {renderIf(
                !isRawContentEmpty(item),
                <div style={{fontSize: 13}} className="ml-3">
                    <SlateRenderer value={convertFromString(item)}/>
                </div>
            )}
        </div>
    )
}

export const DetailViewForm = ({item, onCancel, onEdit}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const [current, setCurrent] = useState('information')

    const {
        photo,
        name,
        short_name,
        religious_order_group,
        target_gender,
        authority_typecd,
        nature_typecd,
        parent,
    } = item ?? {}

    const gender = _.find(TargetGenderTypes, {value: target_gender || parent?.target_gender})?.label
    const nature_label = _.find(NatureTypeInfos, {value: nature_typecd})?.label
    const personnelCount = countPopulatedPersonnel(item)

    const tabs = [
        {
            key: 'information',
            label: t('information'),
            content: <InformationTab item={item} onEdit={onEdit}/>,
        },
        {
            key: 'introduce',
            label: t('introduce'),
            content: <AboutReligiousOrders item={item} onEdit={onEdit}/>,
        },
        {
            key: 'personnel',
            label: `${t('personnel')}${personnelCount ? ` (${personnelCount})` : ''}`,
            content: <PersonnelTab item={item} onEdit={onEdit}/>,
        },
    ]

    return (
        <div className="flex flex-col gap-3">
            <div
                className="relative overflow-hidden -mx-4 -mt-4 flex flex-col flex-center gap-2 py-6 px-4"
                style={{background: 'linear-gradient(135deg, #6d28d9 0%, #1e1b4b 100%)'}}>
                <div
                    className="absolute inset-0 pointer-events-none opacity-10"
                    style={{
                        backgroundImage: 'radial-gradient(circle at 20% 20%, #ffffff 0%, transparent 40%), radial-gradient(circle at 80% 80%, #ffffff 0%, transparent 40%)',
                    }}
                />
                <Avatar
                    size={isSm ? 84 : 104}
                    style={{objectFit: "cover"}}
                    src={photo}
                    icon={<ReligiousFillSvg size={54} className="text-color-500"/>}
                    className="relative flex flex-center bg-white rounded-xl shadow-lg"
                />
                <div className="relative flex flex-col flex-center flex-1 gap-1">
                    <div className="text-center space-x-1 leading-tight">
                        <span className="font-bold text-lg md:text-xl text-white uppercase tracking-wider">
                            {name}
                        </span>
                        {renderIf(
                            short_name,
                            <span className="inline-block font-semibold text-sm text-amber-200 italic">
                                {`(${short_name})`}
                            </span>
                        )}
                    </div>
                    {renderIf(
                        _.some([religious_order_group, parent?.religious_order_group]),
                        <div className="flex items-baseline gap-2 tracking-wider">
                            <span className="text-xs text-white text-opacity-70 whitespace-no-wrap italic">
                                {`${t('religious order group')} : `}
                            </span>
                            <span style={{fontSize: 16}} className="font-bold text-white">
                                {t(religious_order_group || parent?.religious_order_group || '')}
                            </span>
                        </div>
                    )}
                    <div className="flex flex-wrap flex-center gap-1 mt-1">
                        {renderIf(
                            gender,
                            <span
                                style={{backgroundColor: 'rgba(255,255,255,0.15)'}}
                                className="px-2 py-0.5 text-white font-medium text-2xs rounded-full tracking-wide">
                                {t(gender)}
                            </span>
                        )}
                        {renderIf(
                            authority_typecd,
                            <span
                                className="px-2 py-0.5 bg-amber-400 text-amber-900 font-medium text-2xs rounded-full tracking-wide">
                                {t(authority_typecd)}
                            </span>
                        )}
                        {renderIf(
                            nature_label,
                            <span
                                style={{backgroundColor: 'rgba(255,255,255,0.15)'}}
                                className="px-2 py-0.5 text-white font-medium text-2xs rounded-full tracking-wide">
                                {t(nature_label)}
                            </span>
                        )}
                    </div>
                </div>
            </div>
            <Tabs
                centered
                size="small"
                activeKey={current}
                onChange={setCurrent}
                className="custom-tabs-menu"
                items={tabs.map((e) => ({
                    key: e.key,
                    label: <span className="font-medium text-sm">{e.label}</span>,
                    children: e.content,
                }))}
            />

        </div>
    )
}

export const CreateReligiousOrderForm = ({
                                             onCancel = NullAsDefault,
                                             onSubmit = NullAsDefault,
                                         }) => {
    const t = useTranslate()

    const validate = (values) => {
        let errors = {}
        if (_.isEmpty(_.get(values, 'name') ?? undefined)) {
            errors.name = t('required field')
        }
        return errors
    }
    const initialValues = {
        name: undefined,
        target_gender: TargetGenderTypes.Male.value,
        active: 1,
    }

    return (
        <Formik
            initialValues={initialValues}
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            onSubmit={({patron_saint, parent, ...values}) => {
                const changes = shallowDiff(values, initialValues)
                onSubmit(_.omitBy({...changes}, _.isUndefined))
            }}>
            {(formik) => {
                const {values, touched, errors, setFieldValue, handleSubmit, isSubmitting, isValid} = formik
                const onChange = (e) => setFieldValue(e.target.name, e.target.value)
                const hasCountry = !!values?.country_id

                return (
                    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                        <Section icon={IoRibbonOutline} title={t('name of religious')} theme="highlight">
                            <Field label={t('name of religious')} required error={touched.name && errors.name}>
                                <NameInput name="name" value={values.name} onChange={onChange}/>
                            </Field>
                            <Field label={t('short name')}>
                                <ShortNameInput name="short_name" value={values.short_name} onChange={onChange}/>
                            </Field>
                        </Section>

                        <Section icon={IoEarthOutline} title={t('country')} subtitle={t('optional')}>
                            <CountryInput name="country_id" value={values.country_id} form={formik}/>
                        </Section>

                        {hasCountry ? (
                            <Section icon={IoBusinessOutline} title={t('belong to diocese')} subtitle={t('optional')}>
                                <DioceseInput name="diocese" value={values.diocese} form={formik}/>
                                <Field label={t('the branch congregation of')}>
                                    <ParentInput name="parent" value={values.parent} form={formik}/>
                                </Field>
                            </Section>
                        ) : (
                            <Section icon={IoGitNetworkOutline} title={t('religious order group')} subtitle={t('optional')}>
                                <ReligiousOrderGroupInput name="religious_order_group" value={values.religious_order_group} form={formik} onChange={onChange}/>
                            </Section>
                        )}

                        <Section icon={IoStarOutline} title={t('patron saint')} subtitle={t('optional')}>
                            <PatronSaintInput name="patron_saint" value={values.patron_saint} form={formik}/>
                            <Field label={t('target gender')}>
                                <ChipGroup
                                    options={Object.values(TargetGenderTypes)}
                                    value={values.target_gender}
                                    onChange={(v) => setFieldValue('target_gender', v)}
                                />
                            </Field>
                        </Section>

                        <Section icon={IoSchoolOutline} title={t('type')} subtitle={t('optional')}>
                            <Field label={t('authority type')}>
                                <ChipGroup
                                    options={Object.values(AuthorityTypeInfos)}
                                    value={values.authority_typecd}
                                    onChange={(v) => setFieldValue('authority_typecd', v)}
                                />
                            </Field>
                            <Field label={t('nature type')}>
                                <ChipGroup
                                    options={Object.values(NatureTypeInfos)}
                                    value={values.nature_typecd}
                                    onChange={(v) => setFieldValue('nature_typecd', v)}
                                />
                            </Field>
                        </Section>

                        <Section icon={IoCallOutline} title={t('contact information')} subtitle={t('optional')}>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label={t('contact name')}>
                                    <ContactNameInput name="contact_name" value={values.contact_name} onChange={onChange}/>
                                </Field>
                                <Field label={t('phone')}>
                                    <ContactPhoneInput name="contact_phone" value={values.contact_phone} onChange={onChange}/>
                                </Field>
                            </div>
                            <Field label={t('address')}>
                                <AddressInput name="contact_address" value={values.contact_address} onChange={onChange}/>
                            </Field>
                        </Section>

                        <Section icon={IoStatsChartOutline} title={t('status')} subtitle={t('optional')}>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label={t('active')}>
                                    <ChipGroup
                                        options={baseFieldTypes.active}
                                        value={values.active}
                                        onChange={(v) => setFieldValue('active', v)}
                                    />
                                </Field>
                                <Field label={t('highlighted')}>
                                    <ChipGroup
                                        options={baseFieldTypes.active}
                                        value={values.highlighted}
                                        onChange={(v) => setFieldValue('highlighted', v)}
                                    />
                                </Field>
                            </div>
                        </Section>

                        <FormActions onCancel={onCancel} submitText="create" isSubmitting={isSubmitting} isValid={isValid}/>
                    </form>
                )
            }}
        </Formik>
    )
}

const ReligiousOrderEditOverviewTab = ({child}) => child
const ReligiousOrderEditAboutTab = createSlateTab('about', AboutInput, IoBookOutline, 'introduce')
const ReligiousOrderEditHistoryTab = createSlateTab('history', HistoryInput, IoDocumentTextOutline, 'history')
const ReligiousOrderEditBishopTab = createSlateTab('bishops', BishopsInput, IoPeopleOutline, 'bishops')
const ReligiousOrderEditSaintTab = createSlateTab('saints', SaintsInput, IoStarOutline, 'saints')
const ReligiousOrderEditMemberTab = createSlateTab('members', MembersInput, IoPeopleOutline, 'members')
const ReligiousOrderEditChurchTab = createSlateTab('churches', ChurchesInput, IoBusinessOutline, 'church')
const ReligiousOrderEditStatisticsTab = createSlateTab('statistics', StatisticsInput, IoStatsChartOutline, 'other')

export const EditReligiousOrderForm = ({
                                           item,
                                           initialValues,
                                           onCancel = NullAsDefault,
                                           onSubmit = NullAsDefault,
                                       }) => {
    const t = useTranslate()
    const [current, setCurrent] = useState('overview')

    const _initialValues = {
        photo: _.get(initialValues, 'photo', ''),
        name: _.get(initialValues, 'name', ''),
        short_name: _.get(initialValues, 'short_name', ''),
        patron_saint: _.get(initialValues, 'patron_saint', ''),
        patron_saint_id: _.get(initialValues, 'patron_saint.id', ''),
        patron_saint_name: _.get(initialValues, 'patron_saint_name', '') || _.get(initialValues, 'patron_saint.common_name', ''),
        parent: _.get(initialValues, 'parent', ''),
        parent_id: _.get(initialValues, 'parent.id', ''),
        parent_name: _.get(initialValues, 'parent.name', ''),
        religious_order_group: _.get(initialValues, 'religious_order_group', ''),
        target_gender: _.get(initialValues, 'target_gender'),
        active: _.get(initialValues, 'active', 0),
        highlighted: _.get(initialValues, 'highlighted', 0),
        contact_phone: _.get(initialValues, 'contact_phone', ''),
        contact_name: _.get(initialValues, 'contact_name', ''),
        contact_address: _.get(initialValues, 'contact_address', ''),
        country_id: _.get(initialValues, 'country.id', null),
        about: convertFromString(_.get(initialValues, 'about')),
        history: convertFromString(_.get(initialValues, 'history')),
        bishops: convertFromString(_.get(initialValues, 'bishops')),
        saints: convertFromString(_.get(initialValues, 'saints')),
        members: convertFromString(_.get(initialValues, 'members')),
        churches: convertFromString(_.get(initialValues, 'churches')),
        statistics: convertFromString(_.get(initialValues, 'statistics')),
        websites: _.get(initialValues, 'websites', []),
        authority_typecd: _.get(initialValues, 'authority_typecd'),
        nature_typecd: _.get(initialValues, 'nature_typecd'),
        diocese: _.get(initialValues, 'diocese', ''),
        diocese_name: _.get(initialValues, 'diocese_name'),
        diocese_id: _.get(initialValues, 'diocese.id'),
        founder_name: _.get(initialValues, 'founder_name'),
        founding_year: _.get(initialValues, 'founding_year'),
        motto: _.get(initialValues, 'motto', ''),
    }

    const validate = (values) => {
        let errors = {}
        if (_.isEmpty(_.get(values, 'name') ?? undefined)) {
            errors.name = t('required field')
        }
        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={({patron_saint, parent, about, history, bishops, saints, members, churches, statistics, websites, ...values}) => {
                const changes = shallowDiff(values, _initialValues)
                onSubmit(_.omitBy(
                    {
                        ...changes,
                        patron_saint_id: !!patron_saint ? patron_saint?.id : null,
                        parent_id: !!parent ? parent?.id : null,
                        about: about ? convertToString(about) : undefined,
                        history: history ? convertToString(history) : undefined,
                        bishops: bishops ? convertToString(bishops) : undefined,
                        saints: saints ? convertToString(saints) : undefined,
                        members: members ? convertToString(members) : undefined,
                        churches: churches ? convertToString(churches) : undefined,
                        statistics: statistics ? convertToString(statistics) : undefined,
                        websites: JSON.stringify(websites),
                    },
                    _.isUndefined
                ))
            }}>
            {(formik) => {
                const {values, touched, errors, setFieldValue} = formik
                const onChange = (e) => setFieldValue(e.target.name, e.target.value)
                const hasCountry = !!values?.country_id

                const overviewContent = (
                    <div className="flex flex-col gap-4">
                        <Section icon={IoImageOutline} title={t('avatar')} subtitle={t('optional')}>
                            <PhotoInput name="photo" value={values.photo} form={formik} onChange={onChange}/>
                        </Section>

                        <Section icon={IoRibbonOutline} title={t('name of religious')} theme="highlight">
                            <Field label={t('name of religious')} required error={touched.name && errors.name}>
                                <NameInput name="name" value={values.name} onChange={onChange}/>
                            </Field>
                            <Field label={t('short name')}>
                                <ShortNameInput name="short_name" value={values.short_name} onChange={onChange}/>
                            </Field>
                        </Section>

                        <Section icon={IoEarthOutline} title={t('country')} subtitle={t('optional')}>
                            <CountryInput name="country_id" value={values.country_id} form={formik}/>
                        </Section>

                        {hasCountry ? (
                            <Section icon={IoBusinessOutline} title={t('belong to diocese')} subtitle={t('optional')}>
                                <DioceseInput name="diocese" value={values.diocese} form={formik}/>
                                <Field label={t('the branch congregation of')}>
                                    <ParentInput name="parent" value={values.parent} form={formik}/>
                                </Field>
                                <Field label={t('founder name')}>
                                    <FounderNameInput name="founder_name" value={values.founder_name} onChange={onChange}/>
                                </Field>
                                <Field label={t('founding year')}>
                                    <FoundingYearInput name="founding_year" value={values.founding_year} onChange={onChange}/>
                                </Field>
                            </Section>
                        ) : (
                            <Section icon={IoGitNetworkOutline} title={t('religious order group')} subtitle={t('optional')}>
                                <ReligiousOrderGroupInput name="religious_order_group" value={values.religious_order_group} form={formik} onChange={onChange}/>
                                <Field label={t('founder name')}>
                                    <FounderNameInput name="founder_name" value={values.founder_name} onChange={onChange}/>
                                </Field>
                                <Field label={t('founding year')}>
                                    <FoundingYearInput name="founding_year" value={values.founding_year} onChange={onChange}/>
                                </Field>
                                <Field label={t('motto')}>
                                    <MottoInput name="motto" value={values.motto} onChange={onChange}/>
                                </Field>
                            </Section>
                        )}

                        <Section icon={IoStarOutline} title={t('patron saint')} subtitle={t('optional')}>
                            <PatronSaintInput name="patron_saint" value={values.patron_saint} form={formik}/>
                            <Field label={t('target gender')}>
                                <ChipGroup
                                    options={Object.values(TargetGenderTypes)}
                                    value={values.target_gender}
                                    onChange={(v) => setFieldValue('target_gender', v)}
                                />
                            </Field>
                        </Section>

                        <Section icon={IoSchoolOutline} title={t('type')} subtitle={t('optional')}>
                            <Field label={t('authority type')}>
                                <ChipGroup
                                    options={Object.values(AuthorityTypeInfos)}
                                    value={values.authority_typecd}
                                    onChange={(v) => setFieldValue('authority_typecd', v)}
                                />
                            </Field>
                            <Field label={t('nature type')}>
                                <ChipGroup
                                    options={Object.values(NatureTypeInfos)}
                                    value={values.nature_typecd}
                                    onChange={(v) => setFieldValue('nature_typecd', v)}
                                />
                            </Field>
                        </Section>

                        <Section icon={IoCallOutline} title={t('contact information')} subtitle={t('optional')}>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label={t('contact name')}>
                                    <ContactNameInput name="contact_name" value={values.contact_name} onChange={onChange}/>
                                </Field>
                                <Field label={t('phone')}>
                                    <ContactPhoneInput name="contact_phone" value={values.contact_phone} onChange={onChange}/>
                                </Field>
                            </div>
                            <Field label={t('address')}>
                                <AddressInput name="contact_address" value={values.contact_address} onChange={onChange}/>
                            </Field>
                        </Section>

                        <Section icon={IoStatsChartOutline} title={t('status')} subtitle={t('optional')}>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label={t('active')}>
                                    <ChipGroup
                                        options={baseFieldTypes.active}
                                        value={values.active}
                                        onChange={(v) => setFieldValue('active', v)}
                                    />
                                </Field>
                                <Field label={t('highlighted')}>
                                    <ChipGroup
                                        options={baseFieldTypes.active}
                                        value={values.highlighted}
                                        onChange={(v) => setFieldValue('highlighted', v)}
                                    />
                                </Field>
                            </div>
                        </Section>

                        <Section icon={IoLinkOutline} title={t('Linked Pages')} subtitle={t('optional')}>
                            <WebsitesInput name="websites" value={values.websites} onChange={onChange}/>
                        </Section>
                    </div>
                )

                return (
                    <ActionModalWrapper
                        tab={current}
                        action={<FormActionBar submitText="save"/>}
                        onTabChange={(key) => setCurrent(key)}
                        tabs={[
                            {key: 'overview', label: 'overview', component: ReligiousOrderEditOverviewTab},
                            {key: 'about', label: 'introduce', component: ReligiousOrderEditAboutTab},
                            {key: 'history', label: 'history', component: ReligiousOrderEditHistoryTab},
                            {key: 'bishop', label: 'bishop', component: ReligiousOrderEditBishopTab},
                            {key: 'saint', label: 'saints', component: ReligiousOrderEditSaintTab},
                            {key: 'member', label: 'members', component: ReligiousOrderEditMemberTab},
                            {key: 'church', label: 'church', component: ReligiousOrderEditChurchTab},
                            {key: 'statistics', label: 'other', component: ReligiousOrderEditStatisticsTab},
                        ]}>
                        {overviewContent}
                    </ActionModalWrapper>
                )
            }}
        </Formik>
    )
}